import { Box, Stack } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { CustomButton } from "../../../components";
import i18n from "../../../i18n-config";
import { Categorie } from "../../../store/features/categorieSlice";
import { RootState } from "../../../store/state";
import CategorieForm from "./CategorieForm";
import CategorieTable from "./CategorieTable";

function Categories() {
  const categories = useSelector((state: RootState) =>
    Object.values(state.categorie)
  );

  const [modalForm, setModalForm] = useState(false);
  const [selectedItem, setSelectedItem] = useState<Categorie>();

  const onEdit = (item: Categorie) => {
    setSelectedItem(item);
    openModalForm();
  };

  const openModalForm = () => {
    setModalForm(true);
  };

  const closeModalForm = () => {
    setModalForm(false);
  };

  return (
    <Box>
      <Stack mb={3} alignItems="flex-end">
      <CustomButton title={i18n.t("ajouter")} onClick={openModalForm} />
      </Stack>
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 2,
          p: 2,
        }}
      >
        <CategorieTable data={categories} />
      </Box>
      {modalForm ? (
        <CategorieForm
          open={modalForm}
          item={selectedItem}
          onClose={closeModalForm}
        />
      ) : null}
    </Box>
  );
}

export default Categories;
